// LoadingProducts.jsx

import React from "react";
import { useNavigate } from "react-router-dom";
import { Log } from "@phosphor-icons/react";
import { Spinner } from "@phosphor-icons/react";
const NoResultsComponent = ({ message }) => {
  const navigate = useNavigate();
  const handleContinue = () => {
    navigate("/products"); // or your desired route
  };

  return (
    <div
      style={{
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
      className="mt-20"
    >
      <div className="text-center ">
        <p className="h5">{message}</p>
      </div>
      <div className="center mt-20">
        <button className="btn btn-outline-main" onClick={handleContinue}>
          Continue Shopping
        </button>
      </div>
    </div>
  );
};

export default NoResultsComponent;
